"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2864],{

/***/ 60179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ components_Dialog_Dialog; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(43618);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/SimpleCheckbox.js
var SimpleCheckbox = __webpack_require__(44468);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/Actions.js









var dialogTokens = Components/* tokens.dialog */.T.dialog, Container = function(_param) /* @__PURE__ */ {
    var children = _param.children, $largerThanSM = _param.$largerThanSM, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "$largerThanSM"
    ]);
    return (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        marginTop: -1 * (0,cjs.getTokenValue)(dialogTokens.margin.mobile.bottom),
        $largerThanSM: (0,_object_spread/* default */.Z)({
            marginTop: -1 * (0,cjs.getTokenValue)(dialogTokens.margin.desktop.bottom)
        }, $largerThanSM)
    }, props), {
        children: children
    }));
}, ButtonContainer = function(param) {
    var children = param.children, buttonPosition = param.buttonPosition;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        paddingTop: dialogTokens.padding.mobile.betweenElements,
        paddingBottom: dialogTokens.margin.mobile.bottom,
        paddingHorizontal: dialogTokens.margin.mobile.leftRight,
        $largerThanSM: {
            paddingBottom: dialogTokens.margin.desktop.bottom,
            paddingHorizontal: dialogTokens.margin.desktop.leftRight,
            flexDirection: buttonPosition === "stacked" ? "column" : "row"
        },
        gap: dialogTokens.padding.actions.default,
        children: children
    });
}, Actions = function(_param) /* @__PURE__ */ {
    var buttonPosition = _param.buttonPosition, buttonOneProps = _param.buttonOneProps, buttonTwoProps = _param.buttonTwoProps, checkboxProps = _param.checkboxProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonPosition",
        "buttonOneProps",
        "buttonTwoProps",
        "checkboxProps"
    ]);
    return (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            checkboxProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                paddingTop: dialogTokens.margin.mobile.top,
                paddingHorizontal: dialogTokens.margin.mobile.leftRight,
                $largerThanSM: {
                    paddingTop: 0,
                    paddingHorizontal: dialogTokens.margin.desktop.leftRight
                },
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(SimpleCheckbox/* SimpleCheckbox */.A, (0,_object_spread/* default */.Z)({}, checkboxProps))
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(ButtonContainer, {
                buttonPosition: buttonPosition,
                children: [
                    buttonOneProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                        variant: "primary",
                        size: "small",
                        $largerThanSM: {
                            size: "medium",
                            flexGrow: 1
                        }
                    }, buttonOneProps)),
                    buttonTwoProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                        variant: "secondary",
                        size: "small",
                        $largerThanSM: {
                            size: "medium",
                            flexGrow: 1
                        }
                    }, buttonTwoProps))
                ]
            })
        ]
    }));
};


// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/ScrollView/index.js + 1 modules
var ScrollView = __webpack_require__(6765);
// EXTERNAL MODULE: ./node_modules/@tamagui/dialog/dist/esm/Dialog.mjs + 44 modules
var Dialog = __webpack_require__(9914);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/shared/VisuallyHidden.js





var VisuallyHidden = function(_param) {
    var children = _param.children, visible = _param.visible, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "visible"
    ]);
    return visible ? children : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: "absolute",
        width: 1,
        height: 1,
        margin: -1,
        zIndex: -1e4,
        overflow: "hidden",
        opacity: 1e-8,
        pointerEvents: "none"
    }, props), {
        children: children
    }));
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/Content.js









var Content_dialogTokens = Components/* tokens.dialog */.T.dialog, StyledTitle = (0,cjs.styled)(Dialog/* Dialog.Title */.Vq.Title, {
    name: "DialogTitle",
    fontFamily: "$body",
    color: Content_dialogTokens.color.content.default,
    variants: {
        typography: {
            "...fontSize": function(fontSize) {
                return {
                    fontSize: fontSize,
                    fontWeight: fontSize,
                    letterSpacing: fontSize,
                    lineHeight: fontSize
                };
            }
        }
    }
}), StyledDescription = (0,cjs.styled)(Dialog/* Dialog.Description */.Vq.Description, {
    name: "DialogDescription",
    fontFamily: "$body",
    color: Content_dialogTokens.color.content.default,
    variants: {
        typography: {
            "...fontSize": function(fontSize) {
                return {
                    fontSize: fontSize,
                    fontWeight: fontSize,
                    letterSpacing: fontSize,
                    lineHeight: fontSize
                };
            }
        }
    }
}), Title = function(propsIn) {
    var props = (0,cjs.useProps)(propsIn);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledTitle, (0,_object_spread/* default */.Z)({}, props));
}, Description = function(propsIn) {
    var props = (0,cjs.useProps)(propsIn);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledDescription, (0,_object_spread/* default */.Z)({}, props));
}, ScrollViewWrapper = function(param) {
    var children = param.children;
    var smallerThanMD = (0,cjs.useMedia)().smallerThanMD;
    return smallerThanMD ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.ScrollView */.Vq.Sheet.ScrollView, {
        flex: 0,
        children: children
    }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
        children: children
    });
}, Content = function(param) {
    var title = param.title, titleProps = param.titleProps, hideTitle = param.hideTitle, description = param.description, descriptionProps = param.descriptionProps, hideDescription = param.hideDescription, children = param.children;
    /* @__PURE__ */ return (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        flexGrow: 1,
        flexShrink: 1,
        paddingTop: Content_dialogTokens.margin.mobile.top,
        paddingBottom: Content_dialogTokens.margin.mobile.bottom,
        $largerThanSM: {
            paddingTop: Content_dialogTokens.margin.desktop.top,
            paddingBottom: Content_dialogTokens.margin.desktop.bottom
        },
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(VisuallyHidden, {
                visible: !hideTitle,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    paddingHorizontal: Content_dialogTokens.margin.mobile.leftRight,
                    paddingBottom: Content_dialogTokens.padding.titleAndDescription.mobile,
                    $largerThanSM: {
                        paddingHorizontal: Content_dialogTokens.margin.desktop.leftRight,
                        paddingBottom: Content_dialogTokens.padding.titleAndDescription.desktop
                    },
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Title, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        typography: Content_dialogTokens.typography.title.small
                    }, titleProps), {
                        $largerThanSM: (0,_object_spread/* default */.Z)({
                            typography: Content_dialogTokens.typography.title.medium,
                            marginRight: Content_dialogTokens.margin.desktop.titleRight
                        }, titleProps === null || titleProps === void 0 ? void 0 : titleProps.$largerThanSM),
                        children: title
                    }))
                })
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollViewWrapper, {
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    paddingHorizontal: Content_dialogTokens.margin.mobile.leftRight,
                    $largerThanSM: {
                        paddingHorizontal: Content_dialogTokens.margin.desktop.leftRight
                    },
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(VisuallyHidden, {
                            visible: !hideDescription,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                typography: Content_dialogTokens.typography.description.small
                            }, descriptionProps), {
                                $largerThanSM: (0,_object_spread/* default */.Z)({
                                    typography: Content_dialogTokens.typography.description.medium
                                }, descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.$largerThanSM),
                                children: description
                            }))
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(41682);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/tokens.js
var tokens = __webpack_require__(61274);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js
var IconButton = __webpack_require__(7603);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(67177);
;// CONCATENATED MODULE: ./node_modules/expo-blur/build/getBackgroundColor.js
function getBackgroundColor(intensity, tint) {
    var opacity = intensity / 100;
    switch(tint){
        // From Apple iOS 14 Sketch Kit - https://developer.apple.com/design/resources/
        // From Apple iOS 14 Sketch Kit - https://developer.apple.com/design/resources/
        case "dark":
        case "systemMaterialDark":
            return "rgba(25,25,25,".concat(opacity * 0.78, ")");
        case "light":
        case "extraLight":
        case "systemMaterialLight":
        case "systemUltraThinMaterialLight":
        case "systemThickMaterialLight":
            return "rgba(249,249,249,".concat(opacity * 0.78, ")");
        case "default":
        case "prominent":
        case "systemMaterial":
            return "rgba(255,255,255,".concat(opacity * 0.3, ")");
        case "regular":
            return "rgba(179,179,179,".concat(opacity * 0.82, ")");
        case "systemThinMaterial":
            return "rgba(199,199,199,".concat(opacity * 0.97, ")");
        case "systemChromeMaterial":
            return "rgba(255,255,255,".concat(opacity * 0.75, ")");
        case "systemChromeMaterialLight":
            return "rgba(255,255,255,".concat(opacity * 0.97, ")");
        case "systemUltraThinMaterial":
            return "rgba(191,191,191,".concat(opacity * 0.44, ")");
        case "systemThickMaterial":
            return "rgba(191,191,191,".concat(opacity * 0.44, ")");
        case "systemThickMaterialDark":
            return "rgba(37,37,37,".concat(opacity * 0.9, ")");
        case "systemThinMaterialDark":
            return "rgba(37,37,37,".concat(opacity * 0.7, ")");
        case "systemUltraThinMaterialDark":
            return "rgba(37,37,37,".concat(opacity * 0.55, ")");
        case "systemChromeMaterialDark":
            return "rgba(0,0,0,".concat(opacity * 0.75, ")");
        case "systemThinMaterialLight":
            return "rgba(199,199,199,".concat(opacity * 0.78, ")");
    }
}

;// CONCATENATED MODULE: ./node_modules/expo-blur/build/BlurView.web.js
// Copyright © 2024 650 Industries.
"use client";

function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}



var BlurView = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var _tint = _param.tint, tint = _tint === void 0 ? "default" : _tint, _intensity = _param.intensity, intensity = _intensity === void 0 ? 50 : _intensity, style = _param.style, props = (0,_object_without_properties/* default */.Z)(_param, [
        "tint",
        "intensity",
        "style"
    ]);
    var blurViewRef = (0,react.useRef)(null);
    var blurStyle = getBlurStyle({
        tint: tint,
        intensity: intensity
    });
    (0,react.useImperativeHandle)(ref, function() {
        return {
            setNativeProps: function(nativeProps) {
                var _$ref, _$ref1;
                if (!((_$ref = blurViewRef.current) === null || _$ref === void 0 ? void 0 : _$ref.style)) {
                    return;
                }
                var _$ref2;
                // @ts-expect-error: `style.intensity` is not defined in the types
                var nextIntensity = (_$ref2 = (_$ref1 = nativeProps.style) === null || _$ref1 === void 0 ? void 0 : _$ref1.intensity) !== null && _$ref2 !== void 0 ? _$ref2 : intensity;
                var blurStyle = getBlurStyle({
                    intensity: nextIntensity,
                    tint: tint !== null && tint !== void 0 ? tint : "default"
                });
                if (nativeProps.style) {
                    for(var key in nativeProps.style){
                        if (key !== "intensity") {
                            blurViewRef.current.style[key] = nativeProps.style[key];
                        }
                    }
                }
                blurViewRef.current.style.backgroundColor = blurStyle.backgroundColor;
                blurViewRef.current.style.backdropFilter = blurStyle.backdropFilter;
                blurViewRef.current.style["webkitBackdropFilter"] = blurStyle.WebkitBackdropFilter;
            }
        };
    }, [
        intensity,
        tint
    ]);
    return /*#__PURE__*/ React.createElement(View/* default */.Z, _extends({}, props, {
        style: [
            style,
            blurStyle
        ],
        ref: blurViewRef
    }));
});
function getBlurStyle(param) {
    var intensity = param.intensity, tint = param.tint;
    var blur = "saturate(180%) blur(".concat(Math.min(intensity, 100) * 0.2, "px)");
    return {
        backgroundColor: getBackgroundColor(Math.min(intensity, 100), tint),
        backdropFilter: blur,
        WebkitBackdropFilter: blur
    };
}
/* harmony default export */ var BlurView_web = (BlurView);

;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/BackgroundBlur.js







var BackgroundBlur = function(_param) {
    var blurRadius = _param.blurRadius, props = (0,_object_without_properties/* default */.Z)(_param, [
        "blurRadius"
    ]);
    var intensity = (0,react.useMemo)(function() {
        return (typeof blurRadius == "number" ? blurRadius : (0,cjs.getTokenValue)(blurRadius, "backgroundBlur")) * 5;
    }, [
        blurRadius
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(BlurView_web, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        intensity: intensity
    }));
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/Dialog.js











var Dialog_dialogTokens = Components/* tokens.dialog */.T.dialog, Dialog_Dialog = function(param) {
    var isOpen = param.isOpen, _animation = param.animation, animation = _animation === void 0 ? "accelerateDecelerateFastest" : _animation, setIsOpen = param.setIsOpen, _overlayColor = param.overlayColor, overlayColor = _overlayColor === void 0 ? "dark" : _overlayColor, analyticsName = param.analyticsName, trackImpression = param.trackImpression, _dismissable = param.dismissable, dismissable = _dismissable === void 0 ? !0 : _dismissable, _showCloseButton = param.showCloseButton, showCloseButton = _showCloseButton === void 0 ? !0 : _showCloseButton, children = param.children;
    var overlayProps = overlayColor === "dark" ? {
        backgroundColor: Dialog_dialogTokens.color.scrim
    } : overlayColor === "transparent" ? {
        backgroundColor: void 0
    } : {
        backgroundColor: Dialog_dialogTokens.color.scrimInverse,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(BackgroundBlur, {
            blurRadius: Dialog_dialogTokens.backgroundBlur.default,
            style: {
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0
            }
        })
    }, maxHeightTokenValue = (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.maxHeight), minHeightTokenValue = (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.minHeightWidth), dimensions = (0,useWindowDimensions/* default */.Z)(), maxSheetHeight = (0,react.useMemo)(function() {
        var percent = parseInt(maxHeightTokenValue, 10);
        return cjs.isWeb ? "".concat(percent, "dvh") : 0.01 * percent * dimensions.height;
    }, [
        dimensions.height,
        maxHeightTokenValue
    ]), minSheetHeight = (0,react.useMemo)(function() {
        var percent = parseInt(minHeightTokenValue, 10);
        return cjs.isWeb ? "".concat(percent, "dvh") : 0.01 * percent * dimensions.height;
    }, [
        dimensions.height,
        minHeightTokenValue
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog */.Vq, {
        modal: !0,
        open: isOpen,
        onOpenChange: dismissable ? setIsOpen : void 0,
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Portal */.Vq.Portal, {
                children: [
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Overlay */.Vq.Overlay, (0,_object_spread/* default */.Z)({
                        animation: animation,
                        animateOnly: [
                            "opacity"
                        ],
                        enterStyle: {
                            opacity: 0
                        },
                        exitStyle: {
                            opacity: 0
                        }
                    }, overlayProps), "overlay"),
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Content */.Vq.Content, {
                        animation: animation,
                        animateOnly: [
                            "opacity",
                            "transform"
                        ],
                        enterStyle: {
                            opacity: 0,
                            y: 20
                        },
                        exitStyle: {
                            opacity: 0,
                            y: 20
                        },
                        overflow: "hidden",
                        padding: 0,
                        borderWidth: 0,
                        backgroundColor: Dialog_dialogTokens.color.background.default,
                        borderRadius: Dialog_dialogTokens.cornerRadius.desktop.default,
                        minWidth: (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.minHeightWidth),
                        minHeight: minHeightTokenValue,
                        maxHeight: maxHeightTokenValue,
                        $largerThanSM: {
                            maxWidth: (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.maxWidth)
                        },
                        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            analyticsName: analyticsName,
                            trackImpression: trackImpression,
                            flexGrow: 1,
                            flexShrink: 1,
                            position: "relative",
                            children: [
                                dismissable && showCloseButton && /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Close */.Vq.Close, {
                                    asChild: !0,
                                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                                        size: "large",
                                        analyticsName: "".concat(analyticsName, "-close"),
                                        position: "absolute",
                                        zIndex: 1,
                                        top: 0,
                                        right: 0,
                                        margin: Dialog_dialogTokens.padding.actions.closeIconButton.desktop
                                    })
                                }),
                                children
                            ]
                        })
                    }, "content")
                ]
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Adapt */.Vq.Adapt, {
                when: "smallerThanMD",
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Sheet */.Vq.Sheet, {
                    modal: !0,
                    dismissOnSnapToBottom: dismissable,
                    moveOnKeyboardChange: !0,
                    dismissOnOverlayPress: dismissable,
                    disableDrag: !dismissable,
                    animation: animation,
                    snapPointsMode: "fit",
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Overlay */.Vq.Sheet.Overlay, (0,_object_spread/* default */.Z)({
                            animation: animation,
                            animateOnly: [
                                "opacity"
                            ],
                            enterStyle: {
                                opacity: 0
                            },
                            exitStyle: {
                                opacity: 0
                            }
                        }, overlayProps), "overlay"),
                        dismissable && /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Handle */.Vq.Sheet.Handle, {
                            borderRadius: Dialog_dialogTokens.cornerRadius.mobile.handle,
                            height: Dialog_dialogTokens.mobile.handle.height,
                            width: Dialog_dialogTokens.mobile.handle.width,
                            alignSelf: "center",
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: Dialog_dialogTokens.margin.mobile.handle.bottom,
                            backgroundColor: overlayColor === "dark" ? Dialog_dialogTokens.color.background.mobile.handle : Dialog_dialogTokens.color.background.mobile.handleInverse,
                            opacity: (0,tokens/* getOpacityTokenValue */.vs)(Dialog_dialogTokens.opacity.mobileHandle)
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Frame */.Vq.Sheet.Frame, {
                            backgroundColor: Dialog_dialogTokens.color.background.default,
                            borderTopLeftRadius: Dialog_dialogTokens.cornerRadius.mobile.default,
                            borderTopRightRadius: Dialog_dialogTokens.cornerRadius.mobile.default,
                            maxHeight: maxSheetHeight,
                            minHeight: minSheetHeight,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Adapt.Contents */.Vq.Adapt.Contents, {})
                        })
                    ]
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js




var components_Dialog_Dialog = (0,cjs.withStaticProperties)(Dialog_Dialog, {
    Content: Content,
    Actions: Actions
});



/***/ }),

/***/ 41682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindowDimensions; }
/* harmony export */ });
/* harmony import */ var _Dimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95998);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */

'use client';



function useWindowDimensions() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => _Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get('window')),
    dims = _useState[0],
    setDims = _useState[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    function handleChange(_ref) {
      var window = _ref.window;
      if (window != null) {
        setDims(window);
      }
    }
    _Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].addEventListener */ .Z.addEventListener('change', handleChange);
    // We might have missed an update between calling `get` in render and
    // `addEventListener` in this handler, so we set it here. If there was
    // no change, React will filter out this update as a no-op.
    setDims(_Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get('window'));
    return () => {
      _Dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].removeEventListener */ .Z.removeEventListener('change', handleChange);
    };
  }, []);
  return dims;
}

/***/ }),

/***/ 9914:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vq": function() { return /* binding */ Dialog; }
});

// UNUSED EXPORTS: DialogClose, DialogContent, DialogDescription, DialogOverlay, DialogOverlayFrame, DialogPortal, DialogPortalFrame, DialogSheetContents, DialogTitle, DialogTrigger, DialogWarningProvider, createDialogScope

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/helpers/dist/esm/index.mjs + 5 modules
var dist_esm = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@tamagui/adapt/dist/esm/Adapt.mjs





const AdaptParentContext = react.createContext(null),
  AdaptContents = props => {
    const context = react.useContext(AdaptParentContext);
    if (!context?.Contents) throw new Error( true ? "tamagui.dev/docs/intro/errors#warning-002" : 0);
    return react.createElement(context.Contents, props);
  };
AdaptContents.shouldForwardSpace = !0;
const useAdaptParent = ({
    Contents
  }) => {
    const [when, setWhen] = react.useState(null);
    return {
      AdaptProvider: react.useMemo(() => {
        const context = {
          Contents,
          setWhen
        };
        function AdaptProviderView(props) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(AdaptParentContext.Provider, {
            value: context,
            children: props.children
          });
        }
        return AdaptProviderView;
      }, [Contents]),
      when
    };
  },
  Adapt = (0,dist_esm/* withStaticProperties */.$e)(function ({
    platform,
    when,
    children
  }) {
    const context = react.useContext(AdaptParentContext),
      media = (0,cjs.useMedia)();
    let enabled = !1;
    return typeof when == "function" ? enabled = when({
      media
    }) : (enabled = !platform, platform === "touch" && (enabled = esm/* isTouchable */.wT), platform === "native" && (enabled = !esm/* isWeb */.$L), platform === "web" && (enabled = esm/* isWeb */.$L), platform === "ios" && (enabled = esm/* isIos */.s), platform === "android" && (enabled = esm/* isAndroid */.Dt), when && !media[when] && (enabled = !1)), (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
      enabled && context?.setWhen(when || enabled);
    }, [when, context, enabled]), enabled ? typeof children == "function" ? children({
      enabled,
      media
    }) : children : null;
  }, {
    Contents: AdaptContents
  });

//# sourceMappingURL=Adapt.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/adapt/dist/esm/index.mjs

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/animate-presence/dist/esm/AnimatePresence.mjs + 3 modules
var AnimatePresence = __webpack_require__(26062);
;// CONCATENATED MODULE: ./node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                try {
                    var attr = node.getAttribute(controlAttribute);
                    var alreadyHidden = attr !== null && attr !== 'false';
                    var counterValue = (counterMap.get(node) || 0) + 1;
                    var markerValue = (markerCounter.get(node) || 0) + 1;
                    counterMap.set(node, counterValue);
                    markerCounter.set(node, markerValue);
                    hiddenNodes.push(node);
                    if (counterValue === 1 && alreadyHidden) {
                        uncontrolledNodes.set(node, true);
                    }
                    if (markerValue === 1) {
                        node.setAttribute(markerName, 'true');
                    }
                    if (!alreadyHidden) {
                        node.setAttribute(controlAttribute, 'true');
                    }
                }
                catch (e) {
                    console.error('aria-hidden: cannot operate on ', node, e);
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};

// EXTERNAL MODULE: ./node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(94030);
// EXTERNAL MODULE: ./node_modules/@tamagui/create-context/dist/esm/create-context.mjs
var create_context = __webpack_require__(9838);
// EXTERNAL MODULE: ./node_modules/@tamagui/dismissable/dist/esm/index.mjs + 3 modules
var dismissable_dist_esm = __webpack_require__(69438);
// EXTERNAL MODULE: ./node_modules/@tamagui/use-event/dist/esm/index.mjs + 2 modules
var use_event_dist_esm = __webpack_require__(13989);
// EXTERNAL MODULE: ./node_modules/@tamagui/start-transition/dist/esm/index.mjs
var start_transition_dist_esm = __webpack_require__(28031);
;// CONCATENATED MODULE: ./node_modules/@tamagui/focus-scope/dist/esm/FocusScope.mjs





const AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount",
  AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount",
  EVENT_OPTIONS = {
    bubbles: !1,
    cancelable: !0
  },
  FocusScope = react.forwardRef(function (props, forwardedRef) {
    const childProps = useFocusScope(props, forwardedRef);
    return typeof props.children == "function" ? /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: props.children(childProps)
    }) : react.cloneElement(react.Children.only(props.children), childProps);
  });
function useFocusScope(props, forwardedRef) {
  const {
      loop = !1,
      enabled = !0,
      trapped = !1,
      onMountAutoFocus: onMountAutoFocusProp,
      onUnmountAutoFocus: onUnmountAutoFocusProp,
      forceUnmount,
      children,
      ...scopeProps
    } = props,
    [container, setContainer] = react.useState(null),
    onMountAutoFocus = (0,use_event_dist_esm/* useEvent */.z)(onMountAutoFocusProp),
    onUnmountAutoFocus = (0,use_event_dist_esm/* useEvent */.z)(onUnmountAutoFocusProp),
    lastFocusedElementRef = react.useRef(null),
    composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, node => {
      (0,start_transition_dist_esm/* startTransition */.L)(() => {
        setContainer(node);
      });
    }),
    focusScope = react.useRef({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }).current;
  react.useEffect(() => {
    if (!enabled || !trapped) return;
    const controller = new AbortController();
    function handleFocusIn(event) {
      if (focusScope.paused || !container) return;
      const target = event.target;
      container.contains(target) ? (target?.addEventListener("blur", handleBlur, {
        signal: controller.signal
      }), lastFocusedElementRef.current = target) : FocusScope_focus(lastFocusedElementRef.current, {
        select: !0
      });
    }
    function handleFocusOut(event) {
      controller.abort(), !(focusScope.paused || !container) && (container.contains(event.relatedTarget) || FocusScope_focus(lastFocusedElementRef.current, {
        select: !0
      }));
    }
    function handleBlur() {
      lastFocusedElementRef.current = container;
    }
    return document.addEventListener("focusin", handleFocusIn), document.addEventListener("focusout", handleFocusOut), () => {
      controller.abort(), document.removeEventListener("focusin", handleFocusIn), document.removeEventListener("focusout", handleFocusOut);
    };
  }, [trapped, forceUnmount, container, focusScope.paused]), react.useEffect(() => {
    if (!enabled || !container || forceUnmount) return;
    focusScopesStack.add(focusScope);
    const previouslyFocusedElement = document.activeElement;
    if (!container.contains(previouslyFocusedElement)) {
      const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
      if (container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus), container.dispatchEvent(mountEvent), !mountEvent.defaultPrevented) {
        const candidates = removeLinks(getTabbableCandidates(container));
        focusFirst(candidates, {
          select: !0
        }), document.activeElement === previouslyFocusedElement && FocusScope_focus(container);
      }
    }
    return () => {
      container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
      const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
      container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus), container.dispatchEvent(unmountEvent), unmountEvent.defaultPrevented || FocusScope_focus(previouslyFocusedElement ?? document.body, {
        select: !0
      }), container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus), focusScopesStack.remove(focusScope);
    };
  }, [enabled, container, forceUnmount, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = react.useCallback(event => {
    if (!trapped || !loop || focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey,
      focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container2 = event.currentTarget,
        [first, last] = getTabbableEdges(container2);
      first && last ? !event.shiftKey && focusedElement === last ? (event.preventDefault(), loop && FocusScope_focus(first, {
        select: !0
      })) : event.shiftKey && focusedElement === first && (event.preventDefault(), loop && FocusScope_focus(last, {
        select: !0
      })) : focusedElement === container2 && event.preventDefault();
    }
  }, [loop, trapped, focusScope.paused]);
  return {
    tabIndex: -1,
    ...scopeProps,
    ref: composedRefs,
    onKeyDown: handleKeyDown
  };
}
function focusFirst(candidates, {
  select = !1
} = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) if (FocusScope_focus(candidate, {
    select
  }), document.activeElement !== previouslyFocusedElement) return;
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container),
    first = findVisible(candidates, container),
    last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  const nodes = [],
    walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
      acceptNode: node => {
        const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
        return node.disabled || node.hidden || isHiddenInput ? NodeFilter.FILTER_SKIP : node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; walker.nextNode();) nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  for (const element of elements) if (!isHidden(element, {
    upTo: container
  })) return element;
}
function isHidden(node, {
  upTo
}) {
  if (getComputedStyle(node).visibility === "hidden") return !0;
  for (; node;) {
    if (upTo !== void 0 && node === upTo) return !1;
    if (getComputedStyle(node).display === "none") return !0;
    node = node.parentElement;
  }
  return !1;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function FocusScope_focus(element, {
  select = !1
} = {}) {
  if (element?.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: !0
    }), element !== previouslyFocusedElement && isSelectableInput(element) && select && element.select();
  }
}
const focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      focusScope !== activeFocusScope && activeFocusScope?.pause(), stack = arrayRemove(stack, focusScope), stack.unshift(focusScope);
    },
    remove(focusScope) {
      stack = arrayRemove(stack, focusScope), stack[0]?.resume();
    }
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array],
    index = updatedArray.indexOf(item);
  return index !== -1 && updatedArray.splice(index, 1), updatedArray;
}
function removeLinks(items) {
  return items.filter(item => item.tagName !== "A");
}

//# sourceMappingURL=FocusScope.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/focus-scope/dist/esm/index.mjs

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/portal/dist/esm/index.mjs + 2 modules
var portal_dist_esm = __webpack_require__(86660);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js



var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = (0,tslib_es6.__assign)({ async: true, ssr: false }, options);
    return medium;
}

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = createSidecarMedium();

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = (0,tslib_es6.__rest)(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
    var SideCar = sideCar;
    var containerRef = useMergeRefs([ref, parentRef]);
    var containerProps = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref })),
        forwardProps ? (react.cloneElement(react.Children.only(children), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, (0,tslib_es6.__assign)({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = (0,tslib_es6.__rest)(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, (0,tslib_es6.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

;// CONCATENATED MODULE: ./node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function () {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function () {
    react.useEffect(function () {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function () {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) {
                document.body.removeAttribute(lockAttribute);
            }
            else {
                document.body.setAttribute(lockAttribute, newCounter.toString());
            }
        };
    }, []);
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== document.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(function () { return styleSingleton(); })[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0,tslib_es6.__spreadArray)([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: "margin" }) : null));
}

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) { return (react.createElement(RemoveScroll, (0,tslib_es6.__assign)({}, props, { ref: ref, sideCar: sidecar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);

;// CONCATENATED MODULE: ./node_modules/@tamagui/remove-scroll/dist/esm/RemoveScroll.mjs



const RemoveScroll_RemoveScroll = react.memo(props => props.children ? /* @__PURE__ */(0,jsx_runtime.jsx)(Combination, {
    ...props
  }) : null),
  classNames = Combination.classNames;

//# sourceMappingURL=RemoveScroll.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/remove-scroll/dist/esm/index.mjs

//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(43702);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/ThemeableStack.mjs + 1 modules
var ThemeableStack = __webpack_require__(90099);
;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/constants.mjs

const constants = {},
  SHEET_NAME = "Sheet",
  SHEET_HANDLE_NAME = "SheetHandle",
  SHEET_OVERLAY_NAME = "SheetOverlay",
  SHEET_HIDDEN_STYLESHEET = cjs.isClient ? document.createElement("style") : null;
SHEET_HIDDEN_STYLESHEET && typeof document.head < "u" && document.head.appendChild(SHEET_HIDDEN_STYLESHEET);

//# sourceMappingURL=constants.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-did-finish-ssr/dist/esm/index.mjs
var use_did_finish_ssr_dist_esm = __webpack_require__(96039);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(22805);
;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/SheetContext.mjs


const [createSheetContext, createSheetScope] = (0,create_context/* createContextScope */.b)(SHEET_NAME),
  [SheetProvider, useSheetContext] = createSheetContext(SHEET_NAME, {});

//# sourceMappingURL=SheetContext.mjs.map

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Keyboard/index.js
var Keyboard = __webpack_require__(33668);
;// CONCATENATED MODULE: ./node_modules/@tamagui/use-keyboard-visible/dist/esm/useKeyboardVisible.mjs


const useKeyboardVisible = () => {
  const [isKeyboardVisible, setKeyboardVisible] = react.useState(!1);
  return react.useEffect(() => {
    const keyboardDidShowListener = Keyboard/* default.addListener */.Z.addListener("keyboardDidShow", () => {
        setKeyboardVisible(!0);
      }),
      keyboardDidHideListener = Keyboard/* default.addListener */.Z.addListener("keyboardDidHide", () => {
        setKeyboardVisible(!1);
      });
    return () => {
      keyboardDidHideListener.remove(), keyboardDidShowListener.remove();
    };
  }, []), isKeyboardVisible;
};

//# sourceMappingURL=useKeyboardVisible.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/use-keyboard-visible/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(64645);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Dimensions/index.js
var Dimensions = __webpack_require__(95998);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(67177);
;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/contexts.mjs

const ParentSheetContext = react.createContext({
    zIndex: 1e5
  }),
  SheetInsideSheetContext = react.createContext(null);

//# sourceMappingURL=contexts.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/helpers.mjs
function resisted(y, minY, maxOverflow = 25) {
  if (y < minY) {
    const past = minY - y,
      extra = -(1.1 - 0.15 ** (Math.min(maxOverflow, past) / maxOverflow)) * maxOverflow;
    return minY + extra;
  }
  return y;
}

//# sourceMappingURL=helpers.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-controllable-state/dist/esm/useControllableState.mjs
var useControllableState = __webpack_require__(81430);
;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/useSheetController.mjs

const useSheetController = () => {
    const controller = react.useContext(SheetControllerContext),
      isHidden = controller?.hidden,
      isShowingNonSheet = isHidden && controller?.open;
    return {
      controller,
      isHidden,
      isShowingNonSheet,
      disableDrag: controller?.disableDrag
    };
  },
  SheetControllerContext = react.createContext(null);

//# sourceMappingURL=useSheetController.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/useSheetOpenState.mjs


const useSheetOpenState = props => {
  const {
      isHidden,
      controller
    } = useSheetController(),
    onOpenChangeInternal = val => {
      controller?.onOpenChange?.(val), props.onOpenChange?.(val);
    },
    [open, setOpen] = (0,useControllableState/* useControllableState */.T)({
      prop: controller?.open ?? props.open,
      defaultProp: props.defaultOpen ?? !1,
      onChange: onOpenChangeInternal,
      strategy: "most-recent-wins",
      transition: !0
    });
  return {
    open,
    setOpen,
    isHidden,
    controller
  };
};

//# sourceMappingURL=useSheetOpenState.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/use-constant/dist/esm/index.mjs
var use_constant_dist_esm = __webpack_require__(22827);
;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/useSheetProviderProps.mjs




function useSheetProviderProps(props, state, options = {}) {
  const handleRef = react.useRef(null),
    contentRef = react.useRef(null),
    [frameSize, setFrameSize] = react.useState(0),
    [maxContentSize, setMaxContentSize] = react.useState(0),
    snapPointsMode = props.snapPointsMode ?? "percent",
    snapPointsProp = props.snapPoints ?? (snapPointsMode === "percent" ? [80] : snapPointsMode === "constant" ? [256] : ["fit"]),
    hasFit = snapPointsProp[0] === "fit",
    snapPoints = react.useMemo(() => props.dismissOnSnapToBottom ? [...snapPointsProp, 0] : snapPointsProp, [JSON.stringify(snapPointsProp), props.dismissOnSnapToBottom]),
    [position_, setPositionImmediate] = (0,useControllableState/* useControllableState */.T)({
      prop: props.position,
      defaultProp: props.defaultPosition || (state.open ? 0 : -1),
      onChange: props.onPositionChange,
      strategy: "most-recent-wins",
      transition: !0
    }),
    position = state.open === !1 ? -1 : position_,
    {
      open
    } = state,
    setPosition = react.useCallback(next => {
      props.dismissOnSnapToBottom && next === snapPoints.length - 1 ? state.setOpen(!1) : setPositionImmediate(next);
    }, [props.dismissOnSnapToBottom, snapPoints.length, setPositionImmediate, state.setOpen]);
   false && (0), open && props.dismissOnSnapToBottom && position === snapPoints.length - 1 && setPositionImmediate(0);
  const shouldSetPositionOpen = open && position < 0;
  react.useEffect(() => {
    shouldSetPositionOpen && setPosition(0);
  }, [setPosition, shouldSetPositionOpen]);
  const {
    animationDriver
  } = (0,cjs.useConfiguration)();
  if (!animationDriver) throw new Error("Must set animations in tamagui.config.ts");
  const scrollBridge = (0,use_constant_dist_esm/* useConstant */.h)(() => ({
      enabled: !1,
      y: 0,
      paneY: 0,
      paneMinY: 0,
      scrollStartY: -1,
      drag: () => {},
      release: () => {},
      scrollLock: !1
    })),
    removeScrollEnabled = props.forceRemoveScrollEnabled ?? (open && props.modal),
    maxSnapPoint = snapPoints[0];
  return {
    screenSize: snapPointsMode === "percent" ? frameSize / ((typeof maxSnapPoint == "number" ? maxSnapPoint : 100) / 100) : maxContentSize,
    maxSnapPoint,
    removeScrollEnabled,
    scrollBridge,
    modal: !!props.modal,
    open: state.open,
    setOpen: state.setOpen,
    hidden: !!state.isHidden,
    contentRef,
    handleRef,
    frameSize,
    setFrameSize,
    dismissOnOverlayPress: props.dismissOnOverlayPress ?? !0,
    dismissOnSnapToBottom: props.dismissOnSnapToBottom ?? !1,
    onOverlayComponent: options.onOverlayComponent,
    scope: props.__scopeSheet,
    hasFit,
    position,
    snapPoints,
    snapPointsMode,
    setMaxContentSize,
    setPosition,
    setPositionImmediate,
    onlyShowFrame: !1
  };
}

//# sourceMappingURL=useSheetProviderProps.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/SheetImplementationCustom.mjs
















let hiddenSize = 10000.1;
const SheetImplementationCustom = (0,cjs.themeable)(react.forwardRef(function (props, forwardedRef) {
  const parentSheet = react.useContext(ParentSheetContext),
    {
      animation,
      animationConfig: animationConfigProp,
      modal = !1,
      zIndex = parentSheet.zIndex + 1,
      moveOnKeyboardChange = !1,
      unmountChildrenWhenHidden = !1,
      portalProps,
      containerComponent: ContainerComponent = react.Fragment
    } = props,
    keyboardIsVisible = useKeyboardVisible(),
    state = useSheetOpenState(props),
    [overlayComponent, setOverlayComponent] = react.useState(null),
    providerProps = useSheetProviderProps(props, state, {
      onOverlayComponent: setOverlayComponent
    }),
    {
      frameSize,
      setFrameSize,
      snapPoints,
      snapPointsMode,
      hasFit,
      position,
      setPosition,
      scrollBridge,
      screenSize,
      setMaxContentSize,
      maxSnapPoint
    } = providerProps,
    {
      open,
      controller,
      isHidden
    } = state,
    sheetRef = react.useRef(null),
    ref = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, sheetRef),
    animationConfig = (() => {
      const [animationProp, animationPropConfig] = animation ? Array.isArray(animation) ? animation : [animation] : [];
      return animationConfigProp ?? (animationProp ? {
        ...(0,cjs.getConfig)().animations.animations[animationProp],
        ...animationPropConfig
      } : null);
    })(),
    [isShowingInnerSheet, setIsShowingInnerSheet] = react.useState(!1),
    shouldHideParentSheet = !esm/* isWeb */.$L && modal && isShowingInnerSheet,
    parentSheetContext = react.useContext(SheetInsideSheetContext),
    onInnerSheet = react.useCallback(hasChild => {
      setIsShowingInnerSheet(hasChild);
    }, []),
    positions = react.useMemo(() => snapPoints.map(point => getYPositions(snapPointsMode, point, screenSize, frameSize)), [screenSize, frameSize, snapPoints, snapPointsMode]),
    {
      animationDriver
    } = (0,cjs.useConfiguration)(),
    {
      useAnimatedNumber,
      useAnimatedNumberStyle,
      useAnimatedNumberReaction
    } = animationDriver,
    AnimatedView = animationDriver.View ?? cjs.Stack;
  (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
    if (parentSheetContext && open) return parentSheetContext(!0), () => {
      parentSheetContext(!1);
    };
  }, [parentSheetContext, open]);
  const nextParentContext = react.useMemo(() => ({
      zIndex
    }), [zIndex]),
    animatedNumber = useAnimatedNumber(hiddenSize),
    at = react.useRef(hiddenSize);
  useAnimatedNumberReaction({
    value: animatedNumber,
    hostRef: sheetRef
  }, react.useCallback(value => {
    at.current = value, scrollBridge.paneY = value;
  }, [animationDriver]));
  function stopSpring() {
    animatedNumber.stop(), scrollBridge.onFinishAnimate && (scrollBridge.onFinishAnimate(), scrollBridge.onFinishAnimate = void 0);
  }
  const hasntMeasured = at.current === hiddenSize,
    animateTo = (0,cjs.useEvent)(position2 => {
      if (frameSize === 0) return;
      let toValue = isHidden || position2 === -1 ? screenSize : positions[position2];
      if (at.current !== toValue) {
        if (at.current = toValue, stopSpring(), hasntMeasured || isHidden) {
          animatedNumber.setValue(screenSize, {
            type: "timing",
            duration: 0
          }, () => {
            isHidden || (toValue = positions[position2], at.current = toValue, animatedNumber.setValue(toValue, {
              type: "spring",
              ...animationConfig
            }));
          });
          return;
        }
        animatedNumber.setValue(toValue, {
          type: "spring",
          ...animationConfig
        });
      }
    });
  (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
    screenSize && hasntMeasured && animatedNumber.setValue(screenSize, {
      type: "timing",
      duration: 0
    });
  }, [hasntMeasured, screenSize]), (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
    !frameSize || !screenSize || isHidden || hasntMeasured && !open || animateTo(position);
  }, [isHidden, frameSize, screenSize, open, position]);
  const disableDrag = props.disableDrag ?? controller?.disableDrag,
    themeName = (0,cjs.useThemeName)(),
    [isDragging, setIsDragging] = react.useState(!1),
    panResponder = react.useMemo(() => {
      if (disableDrag || !frameSize || isShowingInnerSheet) return;
      const minY = positions[0];
      scrollBridge.paneMinY = minY;
      let startY = at.current;
      function setPanning(val) {
        setIsDragging(val), SHEET_HIDDEN_STYLESHEET && (val ? SHEET_HIDDEN_STYLESHEET.innerText = ":root * { user-select: none !important; -webkit-user-select: none !important; }" : SHEET_HIDDEN_STYLESHEET.innerText = "");
      }
      const release = ({
          vy,
          dragAt
        }) => {
          isExternalDrag = !1, previouslyScrolling = !1, setPanning(!1);
          const end = dragAt + startY + frameSize * vy * 0.2;
          let closestPoint = 0,
            dist = Number.POSITIVE_INFINITY;
          for (let i = 0; i < positions.length; i++) {
            const position2 = positions[i],
              curDist = end > position2 ? end - position2 : position2 - end;
            curDist < dist && (dist = curDist, closestPoint = i);
          }
          setPosition(closestPoint), animateTo(closestPoint);
        },
        finish = (_e, state2) => {
          release({
            vy: state2.vy,
            dragAt: state2.dy
          });
        };
      let previouslyScrolling = !1;
      const onMoveShouldSet = (e, {
          dy
        }) => {
          if (e.target === providerProps.handleRef.current) return !0;
          const isScrolled = scrollBridge.y !== 0,
            isDraggingUp = dy < 0,
            isNearTop = scrollBridge.paneY - 5 <= scrollBridge.paneMinY;
          return isScrolled ? (previouslyScrolling = !0, !1) : isNearTop && !isScrolled && isDraggingUp && !esm/* isWeb */.$L ? !1 : Math.abs(dy) > 5;
        },
        grant = () => {
          setPanning(!0), stopSpring(), startY = at.current;
        };
      let isExternalDrag = !1;
      return scrollBridge.drag = dy => {
        isExternalDrag || (isExternalDrag = !0, grant());
        const to = dy + startY;
        animatedNumber.setValue(resisted(to, minY), {
          type: "direct"
        });
      }, scrollBridge.release = release, PanResponder/* default.create */.Z.create({
        onMoveShouldSetPanResponder: onMoveShouldSet,
        onPanResponderGrant: grant,
        onPanResponderMove: (_e, {
          dy
        }) => {
          const toFull = dy + startY,
            to = resisted(toFull, minY);
          animatedNumber.setValue(to, {
            type: "direct"
          });
        },
        onPanResponderEnd: finish,
        onPanResponderTerminate: finish,
        onPanResponderRelease: finish
      });
    }, [disableDrag, isShowingInnerSheet, animateTo, frameSize, positions, setPosition]),
    handleAnimationViewLayout = react.useCallback(e => {
      const next = Math.min(e.nativeEvent?.layout.height, Dimensions/* default.get */.Z.get("screen").height);
      next && setFrameSize(next);
    }, [keyboardIsVisible]),
    handleMaxContentViewLayout = react.useCallback(e => {
      const next = Math.min(e.nativeEvent?.layout.height, Dimensions/* default.get */.Z.get("screen").height);
      next && setMaxContentSize(next);
    }, [keyboardIsVisible]),
    animatedStyle = useAnimatedNumberStyle(animatedNumber, val => {
      "worklet";

      return {
        transform: [{
          translateY: frameSize === 0 ? hiddenSize : val
        }]
      };
    }),
    sizeBeforeKeyboard = react.useRef(null);
  react.useEffect(() => {
    if (esm/* isWeb */.$L || !moveOnKeyboardChange) return;
    const keyboardShowListener = Keyboard/* default.addListener */.Z.addListener(esm/* currentPlatform */.ob === "ios" ? "keyboardWillShow" : "keyboardDidShow", e => {
        sizeBeforeKeyboard.current === null && (sizeBeforeKeyboard.current = isHidden || position === -1 ? screenSize : positions[position], animatedNumber.setValue(Math.max(sizeBeforeKeyboard.current - e.endCoordinates.height, 0), {
          type: "timing",
          duration: 250
        }));
      }),
      keyboardDidHideListener = Keyboard/* default.addListener */.Z.addListener("keyboardDidHide", () => {
        sizeBeforeKeyboard.current !== null && (animatedNumber.setValue(sizeBeforeKeyboard.current, {
          type: "timing",
          duration: 250
        }), sizeBeforeKeyboard.current = null);
      });
    return () => {
      keyboardDidHideListener.remove(), keyboardShowListener.remove();
    };
  }, [moveOnKeyboardChange, positions, position, isHidden]);
  const [opacity, setOpacity] = react.useState(open ? 1 : 0);
  open && opacity === 0 && setOpacity(1), react.useEffect(() => {
    if (!open) {
      const tm = setTimeout(() => {
        setOpacity(0);
      }, 400);
      return () => {
        clearTimeout(tm);
      };
    }
  }, [open]);
  const forcedContentHeight = hasFit ? void 0 : snapPointsMode === "percent" ? `${maxSnapPoint}${esm/* isWeb */.$L ? "dvh" : "%"}` : maxSnapPoint,
    contents = /* @__PURE__ */(0,jsx_runtime.jsx)(ParentSheetContext.Provider, {
      value: nextParentContext,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)(SheetProvider, {
        ...providerProps,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
          custom: {
            open
          },
          children: shouldHideParentSheet || !open ? null : overlayComponent
        }), snapPointsMode !== "percent" && /* @__PURE__ */(0,jsx_runtime.jsx)(View/* default */.Z, {
          style: {
            opacity: 0,
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: "none"
          },
          onLayout: handleMaxContentViewLayout
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(AnimatedView, {
          ref,
          ...panResponder?.panHandlers,
          onLayout: handleAnimationViewLayout,
          ...(!isDragging && {
            // @ts-ignore for CSS driver this is necessary to attach the transition
            animation
          }),
          disableClassName: !0,
          style: [{
            position: "absolute",
            zIndex,
            width: "100%",
            height: forcedContentHeight,
            minHeight: forcedContentHeight,
            opacity,
            ...((shouldHideParentSheet || !open) && {
              pointerEvents: "none"
            })
          }, animatedStyle],
          children: props.children
        })]
      })
    }),
    adaptContext = react.useContext(AdaptParentContext),
    shouldMountChildren = !!(opacity || !unmountChildrenWhenHidden);
  if (modal) {
    const modalContents = /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* Portal */.h_, {
      zIndex,
      ...portalProps,
      children: shouldMountChildren && /* @__PURE__ */(0,jsx_runtime.jsx)(ContainerComponent, {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(cjs.Theme, {
          forceClassName: !0,
          name: themeName,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(AdaptParentContext.Provider, {
            value: adaptContext,
            children: contents
          })
        })
      })
    });
    return esm/* isWeb */.$L ? modalContents : /* @__PURE__ */(0,jsx_runtime.jsx)(SheetInsideSheetContext.Provider, {
      value: onInnerSheet,
      children: modalContents
    });
  }
  return contents;
}));
function getYPositions(mode, point, screenSize, frameSize) {
  if (!screenSize || !frameSize) return 0;
  if (mode === "mixed") {
    if (typeof point == "number") return screenSize - Math.min(screenSize, Math.max(0, point));
    if (point === "fit") return screenSize - Math.min(screenSize, frameSize);
    if (point.endsWith("%")) {
      const pct2 = Math.min(100, Math.max(0, Number(point.slice(0, -1)))) / 100;
      return Number.isNaN(pct2) ? (console.warn("Invalid snapPoint percentage string"), 0) : Math.round(screenSize - pct2 * screenSize);
    }
    return console.warn("Invalid snapPoint unknown value"), 0;
  }
  if (mode === "fit") return point === 0 ? screenSize : screenSize - Math.min(screenSize, frameSize);
  if (mode === "constant" && typeof point == "number") return screenSize - Math.min(screenSize, Math.max(0, point));
  const pct = Math.min(100, Math.max(0, Number(point))) / 100;
  return Number.isNaN(pct) ? (console.warn("Invalid snapPoint percentage"), 0) : Math.round(screenSize - pct * screenSize);
}

//# sourceMappingURL=SheetImplementationCustom.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/scroll-view/dist/esm/ScrollView.mjs
var ScrollView = __webpack_require__(85464);
;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/SheetScrollView.mjs





const SHEET_SCROLL_VIEW_NAME = "SheetScrollView",
  SheetScrollView = react.forwardRef(({
    __scopeSheet,
    children,
    onScroll,
    ...props
  }, ref) => {
    const context = useSheetContext(SHEET_SCROLL_VIEW_NAME, __scopeSheet),
      {
        scrollBridge
      } = context,
      scrollRef = react.useRef(null),
      state = react.useRef({
        lastPageY: 0,
        dragAt: 0,
        dys: [],
        // store a few recent dys to get velocity on release
        isScrolling: !1,
        isDragging: !1
      }),
      release = () => {
        if (!state.current.isDragging) return;
        state.current.isDragging = !1, scrollBridge.scrollStartY = -1, state.current.isScrolling = !1;
        let vy = 0;
        if (state.current.dys.length) {
          const recentDys = state.current.dys.slice(-10);
          vy = (recentDys.length ? recentDys.reduce((a, b) => a + b, 0) : 0) / recentDys.length * 0.04;
        }
        state.current.dys = [], scrollBridge.release({
          dragAt: state.current.dragAt,
          vy
        });
      };
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ScrollView/* ScrollView */.p, {
      ref: (0,compose_refs/* composeRefs */.FE)(scrollRef, ref),
      flex: 1,
      scrollEventThrottle: 8,
      onScroll: e => {
        const {
          y
        } = e.nativeEvent.contentOffset;
        scrollBridge.y = y, y > 0 && (scrollBridge.scrollStartY = -1), onScroll?.(e);
      },
      onStartShouldSetResponder: () => (scrollBridge.scrollStartY = -1, state.current.isDragging = !0, !0),
      onMoveShouldSetResponder: () => !1,
      onResponderRelease: release,
      className: "_ovs-contain",
      ...props,
      children: react.useMemo(() => children, [children])
    });
  });

//# sourceMappingURL=SheetScrollView.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/useSheetOffscreenSize.mjs
const useSheetOffscreenSize = ({
  snapPoints,
  position,
  screenSize,
  frameSize,
  snapPointsMode
}) => {
  if (snapPointsMode === "fit") return 0;
  if (snapPointsMode === "constant") {
    const maxSize2 = Number(snapPoints[0]),
      currentSize2 = Number(snapPoints[position] ?? 0);
    return maxSize2 - currentSize2;
  }
  if (snapPointsMode === "percent") {
    const maxPercentOpened = Number(snapPoints[0]) / 100,
      percentOpened = Number(snapPoints[position] ?? 0) / 100;
    return (maxPercentOpened - percentOpened) * screenSize;
  }
  const maxSnapPoint = snapPoints[0];
  if (maxSnapPoint === "fit") return 0;
  const maxSize = typeof maxSnapPoint == "string" ? Number(maxSnapPoint.slice(0, -1)) / 100 * screenSize : maxSnapPoint,
    currentSnapPoint = snapPoints[position] ?? 0,
    currentSize = typeof currentSnapPoint == "string" ? Number(currentSnapPoint.slice(0, -1)) / 100 * screenSize : currentSnapPoint,
    offscreenSize = maxSize - currentSize;
  return Number.isNaN(offscreenSize) ? 0 : offscreenSize;
};

//# sourceMappingURL=useSheetOffscreenSize.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/createSheet.mjs















function createSheet({
  Handle,
  Frame,
  Overlay
}) {
  const SheetHandle = Handle.styleable(({
      __scopeSheet,
      ...props
    }, forwardedRef) => {
      const context = useSheetContext(SHEET_HANDLE_NAME, __scopeSheet),
        composedRef = (0,compose_refs/* useComposedRefs */.ex)(context.handleRef, forwardedRef);
      return context.onlyShowFrame ? null :
      // @ts-ignore
      /* @__PURE__ */
      (0,jsx_runtime.jsx)(Handle, {
        ref: composedRef,
        onPress: () => {
          const max = context.snapPoints.length + (context.dismissOnSnapToBottom ? -1 : 0),
            nextPos = (context.position + 1) % max;
          context.setPosition(nextPos);
        },
        open: context.open,
        ...props
      });
    }),
    SheetOverlay = Overlay.extractable((0,react.memo)(propsIn => {
      const {
          __scopeSheet,
          ...props
        } = propsIn,
        context = useSheetContext(SHEET_OVERLAY_NAME, __scopeSheet),
        element = (0,react.useMemo)(() =>
        // @ts-ignore
        /* @__PURE__ */
        (0,jsx_runtime.jsx)(Overlay, {
          ...props,
          onPress: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPress, context.dismissOnOverlayPress ? () => {
            context.setOpen(!1);
          } : void 0)
        }), [props.onPress, context.dismissOnOverlayPress]);
      return (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
        context.onOverlayComponent?.(element);
      }, [element]), context.onlyShowFrame, null;
    })),
    SheetFrame = Frame.extractable((0,react.forwardRef)(({
      __scopeSheet,
      adjustPaddingForOffscreenContent,
      disableHideBottomOverflow,
      children,
      ...props
    }, forwardedRef) => {
      const context = useSheetContext(SHEET_NAME, __scopeSheet),
        {
          hasFit,
          removeScrollEnabled,
          frameSize,
          contentRef,
          open
        } = context,
        composedContentRef = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, contentRef),
        offscreenSize = useSheetOffscreenSize(context),
        sheetContents = (0,react.useMemo)(() =>
        // @ts-ignore
        /* @__PURE__ */
        (0,jsx_runtime.jsxs)(Frame, {
          ref: composedContentRef,
          flex: hasFit ? 0 : 1,
          height: hasFit ? void 0 : frameSize,
          pointerEvents: open ? "auto" : "none",
          ...props,
          children: [children, adjustPaddingForOffscreenContent && /* @__PURE__ */(0,jsx_runtime.jsx)(cjs.Stack, {
            "data-sheet-offscreen-pad": !0,
            height: offscreenSize,
            width: "100%"
          })]
        }), [open, props, frameSize, offscreenSize, adjustPaddingForOffscreenContent, hasFit]);
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(RemoveScroll_RemoveScroll, {
          forwardProps: !0,
          enabled: removeScrollEnabled,
          allowPinchZoom: !0,
          shards: [contentRef],
          removeScrollBar: !1,
          children: sheetContents
        }), !disableHideBottomOverflow &&
        // @ts-ignore
        /* @__PURE__ */
        (0,jsx_runtime.jsx)(Frame, {
          ...props,
          componentName: "SheetCover",
          children: null,
          position: "absolute",
          bottom: "-100%",
          zIndex: -1,
          height: context.frameSize,
          left: 0,
          right: 0,
          borderWidth: 0,
          borderRadius: 0,
          shadowOpacity: 0
        })]
      });
    })),
    Sheet = (0,react.forwardRef)(function (props, ref) {
      const hydrated = (0,use_did_finish_ssr_dist_esm/* useDidFinishSSR */.SZ)(),
        {
          isShowingNonSheet
        } = useSheetController();
      let SheetImplementation = SheetImplementationCustom;
      return props.native && Platform/* default.OS */.Z.OS, isShowingNonSheet || !hydrated ? null : /* @__PURE__ */(0,jsx_runtime.jsx)(SheetImplementation, {
        ref,
        ...props
      });
    }),
    components = {
      Frame: SheetFrame,
      Overlay: SheetOverlay,
      Handle: SheetHandle,
      ScrollView: SheetScrollView
    },
    Controlled = (0,dist_esm/* withStaticProperties */.$e)(Sheet, components);
  return (0,dist_esm/* withStaticProperties */.$e)(Sheet, {
    ...components,
    Controlled
  });
}

//# sourceMappingURL=createSheet.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/Sheet.mjs
/* provided dependency */ var process = __webpack_require__(34155);






const Handle = (0,cjs.styled)(Stacks/* XStack */.sL, {
    name: SHEET_HANDLE_NAME,
    variants: {
      open: {
        true: {
          pointerEvents: "auto"
        },
        false: {
          opacity: 0,
          pointerEvents: "none"
        }
      },
      unstyled: {
        false: {
          height: 10,
          borderRadius: 100,
          backgroundColor: "$background",
          zIndex: 10,
          marginHorizontal: "35%",
          marginBottom: "$2",
          opacity: 0.5,
          hoverStyle: {
            opacity: 0.7
          }
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  Overlay = (0,cjs.styled)(ThemeableStack/* ThemeableStack */.K, {
    name: SHEET_OVERLAY_NAME,
    variants: {
      open: {
        true: {
          opacity: 1,
          pointerEvents: "auto"
        },
        false: {
          opacity: 0,
          pointerEvents: "none"
        }
      },
      unstyled: {
        false: {
          fullscreen: !0,
          position: "absolute",
          backgrounded: !0,
          zIndex: 99999,
          pointerEvents: "auto"
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  Frame = (0,cjs.styled)(Stacks/* YStack */.FA, {
    name: SHEET_NAME,
    variants: {
      unstyled: {
        false: {
          flex: 1,
          backgroundColor: "$background",
          borderTopLeftRadius: "$true",
          borderTopRightRadius: "$true",
          width: "100%",
          maxHeight: "100%",
          overflow: "hidden"
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  Sheet = createSheet({
    Frame,
    Handle,
    Overlay
  }),
  SheetOverlayFrame = (/* unused pure expression or super */ null && (Overlay)),
  SheetHandleFrame = (/* unused pure expression or super */ null && (Handle));

//# sourceMappingURL=Sheet.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/sheet/dist/esm/SheetController.mjs




const SheetController = ({
  children,
  onOpenChange: onOpenChangeProp,
  ...value
}) => {
  const onOpenChange = (0,cjs.useEvent)(onOpenChangeProp),
    memoValue = react.useMemo(() => ({
      open: value.open,
      hidden: value.hidden,
      disableDrag: value.disableDrag,
      onOpenChange
    }), [onOpenChange, value.open, value.hidden, value.disableDrag]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SheetControllerContext.Provider, {
    value: memoValue,
    children
  });
};

//# sourceMappingURL=SheetController.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/stacks/dist/esm/NestingContext.mjs

const ButtonNestingContext = react.createContext(!1);

//# sourceMappingURL=NestingContext.mjs.map

// EXTERNAL MODULE: ./node_modules/@tamagui/text/dist/esm/Headings.mjs
var Headings = __webpack_require__(92976);
// EXTERNAL MODULE: ./node_modules/@tamagui/text/dist/esm/Paragraph.mjs
var Paragraph = __webpack_require__(86706);
;// CONCATENATED MODULE: ./node_modules/@tamagui/dialog/dist/esm/Dialog.mjs
/* provided dependency */ var Dialog_process = __webpack_require__(34155);


















const DIALOG_NAME = "Dialog",
  [createDialogContext, createDialogScope] = (0,create_context/* createContextScope */.b)(DIALOG_NAME),
  [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME),
  TRIGGER_NAME = "DialogTrigger",
  DialogTriggerFrame = (0,cjs.styled)(cjs.View, {
    name: TRIGGER_NAME
  }),
  DialogTrigger = DialogTriggerFrame.styleable(function (props, forwardedRef) {
    const {
        __scopeDialog,
        ...triggerProps
      } = props,
      isInsideButton = react.useContext(ButtonNestingContext),
      context = useDialogContext(TRIGGER_NAME, __scopeDialog),
      composedTriggerRef = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ButtonNestingContext.Provider, {
      value: !0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(DialogTriggerFrame, {
        tag: isInsideButton ? "span" : "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onPress: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPress, context.onOpenToggle)
      })
    });
  }),
  PORTAL_NAME = "DialogPortal",
  [PortalProvider, usePortalContext] = createDialogContext(PORTAL_NAME, {
    forceMount: void 0
  }),
  DialogPortalFrame = (0,cjs.styled)(Stacks/* YStack */.FA, {
    pointerEvents: "none",
    variants: {
      unstyled: {
        false: {
          alignItems: "center",
          justifyContent: "center",
          fullscreen: !0,
          zIndex: 1e5,
          ...(esm/* isWeb */.$L && {
            maxHeight: "100vh",
            position: "fixed"
          })
        }
      }
    },
    defaultVariants: {
      unstyled: Dialog_process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  DialogPortalItem = props => {
    const themeName = (0,cjs.useThemeName)(),
      context = useDialogContext(PORTAL_NAME, props.__scopeDialog);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* PortalItem */.b5, {
      hostName: props.hostName,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(DialogPortalItemContent, {
        ...props,
        themeName,
        context
      })
    });
  };
function DialogPortalItemContent(props) {
  const {
    __scopeDialog,
    children,
    context,
    themeName,
    space,
    spaceDirection,
    separator
  } = props;
  let childrenSpaced = children;
  return (space || separator) && (childrenSpaced = (0,cjs.spacedChildren)({
    children,
    separator,
    space,
    direction: spaceDirection
  })), /* @__PURE__ */(0,jsx_runtime.jsx)(DialogProvider, {
    scope: __scopeDialog,
    ...context,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(cjs.Theme, {
      name: themeName,
      children: childrenSpaced
    })
  });
}
const DialogPortal = props => {
    const {
        __scopeDialog,
        forceMount,
        children,
        ...frameProps
      } = props,
      context = useDialogContext(PORTAL_NAME, __scopeDialog),
      isShowing = forceMount || context.open,
      [isFullyHidden, setIsFullyHidden] = react.useState(!isShowing);
    isShowing && isFullyHidden && setIsFullyHidden(!1);
    const handleExitComplete = react.useCallback(() => {
        setIsFullyHidden(!0);
      }, []),
      contents = /* @__PURE__ */(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        onExitComplete: handleExitComplete,
        children: isShowing ? children : null
      });
    if (useShowDialogSheet(context)) return children;
    if (context.modal) {
      if (isFullyHidden) return null;
      const framedContents = /* @__PURE__ */(0,jsx_runtime.jsx)(PortalProvider, {
        scope: __scopeDialog,
        forceMount,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(DialogPortalFrame, {
          pointerEvents: isShowing ? "auto" : "none",
          ...frameProps,
          children: contents
        })
      });
      return esm/* isWeb */.$L ? /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* Portal */.h_, {
        zIndex: props.zIndex ?? 1e5,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(PassthroughTheme, {
          children: framedContents
        })
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(DialogPortalItem, {
        __scopeDialog,
        children: framedContents
      });
    }
    return contents;
  },
  PassthroughTheme = ({
    children
  }) => {
    const themeName = (0,cjs.useThemeName)();
    return /* @__PURE__ */(0,jsx_runtime.jsx)(cjs.Theme, {
      name: themeName,
      forceClassName: !0,
      children
    });
  },
  OVERLAY_NAME = "DialogOverlay",
  DialogOverlayFrame = (0,cjs.styled)(Overlay, {
    name: OVERLAY_NAME
  }),
  DialogOverlay = DialogOverlayFrame.extractable(react.forwardRef(function ({
    __scopeDialog,
    ...props
  }, forwardedRef) {
    const portalContext = usePortalContext(OVERLAY_NAME, __scopeDialog),
      {
        forceMount = portalContext.forceMount,
        ...overlayProps
      } = props,
      context = useDialogContext(OVERLAY_NAME, __scopeDialog),
      showSheet = useShowDialogSheet(context);
    return !forceMount && (!context.modal || showSheet) ? null : /* @__PURE__ */(0,jsx_runtime.jsx)(DialogOverlayFrame, {
      "data-state": getState(context.open),
      pointerEvents: context.open ? "auto" : "none",
      ...overlayProps,
      ref: forwardedRef
    });
  })),
  CONTENT_NAME = "DialogContent",
  DialogContentFrame = (0,cjs.styled)(ThemeableStack/* ThemeableStack */.K, {
    name: CONTENT_NAME,
    tag: "dialog",
    variants: {
      size: {
        "...size": (val, extras) => ({})
      },
      unstyled: {
        false: {
          position: "relative",
          backgrounded: !0,
          padded: !0,
          radiused: !0,
          elevate: !0,
          zIndex: 1e5
        }
      }
    },
    defaultVariants: {
      size: "$true",
      unstyled: Dialog_process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  DialogContent = DialogContentFrame.extractable(react.forwardRef(function ({
    __scopeDialog,
    ...props
  }, forwardedRef) {
    const portalContext = usePortalContext(CONTENT_NAME, __scopeDialog),
      {
        forceMount = portalContext.forceMount,
        ...contentProps
      } = props,
      context = useDialogContext(CONTENT_NAME, __scopeDialog),
      contents = context.modal ? /* @__PURE__ */(0,jsx_runtime.jsx)(DialogContentModal, {
        context,
        ...contentProps,
        ref: forwardedRef
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(DialogContentNonModal, {
        context,
        ...contentProps,
        ref: forwardedRef
      });
    return !esm/* isWeb */.$L || context.disableRemoveScroll ? contents : /* @__PURE__ */(0,jsx_runtime.jsx)(RemoveScroll_RemoveScroll, {
      forwardProps: !0,
      enabled: context.open,
      allowPinchZoom: context.allowPinchZoom,
      shards: [context.contentRef],
      removeScrollBar: !1,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        "data-remove-scroll-container": !0,
        className: "_dsp_contents",
        children: contents
      })
    });
  })),
  DialogContentModal = react.forwardRef(({
    children,
    context,
    ...props
  }, forwardedRef) => {
    const contentRef = react.useRef(null),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, context.contentRef, contentRef);
    return esm/* isWeb */.$L && react.useEffect(() => {
      if (!context.open) return;
      const content = contentRef.current;
      if (content) return hideOthers(content);
    }, [context.open]), /* @__PURE__ */(0,jsx_runtime.jsx)(DialogContentImpl, {
      ...props,
      context,
      ref: composedRefs,
      trapFocus: context.open,
      disableOutsidePointerEvents: !0,
      onCloseAutoFocus: (0,dist_esm/* composeEventHandlers */.Mj)(props.onCloseAutoFocus, event => {
        event.preventDefault(), context.triggerRef.current?.focus();
      }),
      onPointerDownOutside: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPointerDownOutside, event => {
        const originalEvent = event.detail.originalEvent,
          ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === !0;
        (originalEvent.button === 2 || ctrlLeftClick) && event.preventDefault();
      }),
      onFocusOutside: (0,dist_esm/* composeEventHandlers */.Mj)(props.onFocusOutside, event => event.preventDefault()),
      ...(!props.unstyled && {
        outlineStyle: "none"
      }),
      children
    });
  }),
  DialogContentNonModal = react.forwardRef((props, forwardedRef) => {
    const hasInteractedOutsideRef = react.useRef(!1);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(DialogContentImpl, {
      ...props,
      ref: forwardedRef,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      onCloseAutoFocus: event => {
        props.onCloseAutoFocus?.(event), event.defaultPrevented || (hasInteractedOutsideRef.current || props.context.triggerRef.current?.focus(), event.preventDefault()), hasInteractedOutsideRef.current = !1;
      },
      onInteractOutside: event => {
        props.onInteractOutside?.(event), event.defaultPrevented || (hasInteractedOutsideRef.current = !0);
        const target = event.target,
          trigger = props.context.triggerRef.current;
        if (!(trigger instanceof HTMLElement)) return;
        trigger.contains(target) && event.preventDefault();
      }
    });
  }),
  DialogContentImpl = react.forwardRef((props, forwardedRef) => {
    const {
        __scopeDialog,
        trapFocus,
        onOpenAutoFocus,
        onCloseAutoFocus,
        disableOutsidePointerEvents,
        onEscapeKeyDown,
        onPointerDownOutside,
        onFocusOutside,
        onInteractOutside,
        context,
        ...contentProps
      } = props,
      contentRef = react.useRef(null),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, contentRef),
      showSheet = useShowDialogSheet(context),
      contents = /* @__PURE__ */(0,jsx_runtime.jsx)(DialogContentFrame, {
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": getState(context.open),
        ...contentProps
      });
    return showSheet ? /* @__PURE__ */(0,jsx_runtime.jsx)(DialogPortalItem, {
      hostName: getSheetContentsName(context),
      children: contentProps.children
    }) : esm/* isWeb */.$L ? /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(dismissable_dist_esm/* Dismissable */.XA, {
        disableOutsidePointerEvents: context.open && disableOutsidePointerEvents,
        forceUnmount: !context.open,
        onEscapeKeyDown,
        onPointerDownOutside,
        onFocusOutside,
        onInteractOutside,
        ref: composedRefs,
        onDismiss: () => context.onOpenChange(!1),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(FocusScope, {
          loop: !0,
          enabled: context.open,
          trapped: trapFocus,
          onMountAutoFocus: onOpenAutoFocus,
          forceUnmount: !context.open,
          onUnmountAutoFocus: onCloseAutoFocus,
          children: contents
        })
      }),  false && /* @__PURE__ */0]
    }) : contents;
  }),
  DialogTitleFrame = (0,cjs.styled)(Headings.H2, {
    name: "DialogTitle"
  }),
  DialogTitle = DialogTitleFrame.styleable(function (props, forwardedRef) {
    const {
        __scopeDialog,
        ...titleProps
      } = props,
      context = useDialogContext("DialogTitle", __scopeDialog);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(DialogTitleFrame, {
      id: context.titleId,
      ...titleProps,
      ref: forwardedRef
    });
  }),
  DialogDescriptionFrame = (0,cjs.styled)(Paragraph/* Paragraph */.n, {
    name: "DialogDescription"
  }),
  DESCRIPTION_NAME = "DialogDescription",
  DialogDescription = DialogDescriptionFrame.styleable(function (props, forwardedRef) {
    const {
        __scopeDialog,
        ...descriptionProps
      } = props,
      context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(DialogDescriptionFrame, {
      id: context.descriptionId,
      ...descriptionProps,
      ref: forwardedRef
    });
  }),
  CLOSE_NAME = "DialogClose",
  DialogCloseFrame = (0,cjs.styled)(cjs.View, {
    name: CLOSE_NAME,
    tag: "button"
  }),
  DialogClose = DialogCloseFrame.styleable((props, forwardedRef) => {
    const {
        __scopeDialog,
        displayWhenAdapted,
        ...closeProps
      } = props,
      context = useDialogContext(CLOSE_NAME, __scopeDialog, {
        warn: !1,
        fallback: {}
      }),
      isSheet = useShowDialogSheet(context),
      isInsideButton = react.useContext(ButtonNestingContext);
    return isSheet && !displayWhenAdapted ? null : /* @__PURE__ */(0,jsx_runtime.jsx)(DialogCloseFrame, {
      accessibilityLabel: "Dialog Close",
      tag: isInsideButton ? "span" : "button",
      ...closeProps,
      ref: forwardedRef,
      onPress: (0,dist_esm/* composeEventHandlers */.Mj)(props.onPress, () => {
        context.onOpenChange(!1);
      })
    });
  });
function getState(open) {
  return open ? "open" : "closed";
}
const TITLE_WARNING_NAME = "DialogTitleWarning",
  [DialogWarningProvider, useWarningContext] = (0,create_context/* createContext */.k)(TITLE_WARNING_NAME, {
    contentName: CONTENT_NAME,
    titleName: "DialogTitle",
    docsSlug: "dialog"
  }),
  TitleWarning = ({
    titleId
  }) => {
    if (false) {}
    return null;
  },
  DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning",
  DescriptionWarning = ({
    contentRef,
    descriptionId
  }) => {
    if (false) {}
    return null;
  },
  Dialog = (0,dist_esm/* withStaticProperties */.$e)(react.forwardRef(function (props, ref) {
    const {
        __scopeDialog,
        children,
        open: openProp,
        defaultOpen = !1,
        onOpenChange,
        modal = !0,
        allowPinchZoom = !1,
        disableRemoveScroll = !1
      } = props,
      baseId = react.useId(),
      scopeId = `scope-${baseId}`,
      contentId = `content-${baseId}`,
      titleId = `title-${baseId}`,
      descriptionId = `description-${baseId}`,
      scopeKey = __scopeDialog ? Object.keys(__scopeDialog)[0] : scopeId,
      sheetContentsName = getSheetContentsName({
        scopeKey,
        contentId
      }),
      triggerRef = react.useRef(null),
      contentRef = react.useRef(null),
      [open, setOpen] = (0,useControllableState/* useControllableState */.T)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
      }),
      onOpenToggle = react.useCallback(() => {
        setOpen(prevOpen => !prevOpen);
      }, [setOpen]),
      context = {
        scope: __scopeDialog,
        scopeKey,
        triggerRef,
        contentRef,
        contentId,
        titleId,
        descriptionId,
        open,
        onOpenChange: setOpen,
        onOpenToggle,
        modal,
        allowPinchZoom
      },
      {
        when,
        AdaptProvider
      } = useAdaptParent({
        Contents: react.useCallback(props2 => /* @__PURE__ */(0,jsx_runtime.jsx)(portal_dist_esm/* PortalHost */.$2, {
          forwardProps: props2,
          name: sheetContentsName
        }), [sheetContentsName])
      });
    return react.useImperativeHandle(ref, () => ({
      open: setOpen
    }), [setOpen]), /* @__PURE__ */(0,jsx_runtime.jsx)(AdaptProvider, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(DialogProvider, {
        ...context,
        sheetBreakpoint: when,
        disableRemoveScroll,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(DialogSheetController, {
          onOpenChange: setOpen,
          __scopeDialog,
          children
        })
      })
    });
  }), {
    Trigger: DialogTrigger,
    Portal: DialogPortal,
    Overlay: DialogOverlay,
    Content: DialogContent,
    Title: DialogTitle,
    Description: DialogDescription,
    Close: DialogClose,
    Sheet: Sheet.Controlled,
    Adapt: Adapt
  });
const DialogSheetContents = ({
    name,
    ...props
  }) => /* @__PURE__ */jsx(PortalHost, {
    forwardProps: props,
    name
  }),
  getSheetContentsName = ({
    scopeKey,
    contentId
  }) => `${scopeKey || contentId}SheetContents`,
  DialogSheetController = props => {
    const context = useDialogContext("DialogSheetController", props.__scopeDialog),
      showSheet = useShowDialogSheet(context),
      breakpointActive = useSheetBreakpointActive(context),
      getShowSheet = (0,cjs.useGet)(showSheet);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(SheetController, {
      onOpenChange: val => {
        getShowSheet() && props.onOpenChange?.(val);
      },
      open: context.open,
      hidden: breakpointActive === !1,
      children: props.children
    });
  },
  useSheetBreakpointActive = context => {
    const media = (0,cjs.useMedia)();
    return context.sheetBreakpoint ? context.sheetBreakpoint === !0 ? !0 : media[context.sheetBreakpoint] : !1;
  },
  useShowDialogSheet = context => {
    const breakpointActive = useSheetBreakpointActive(context);
    return context.open === !1 ? !1 : breakpointActive;
  };

//# sourceMappingURL=Dialog.mjs.map


/***/ }),

/***/ 85464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ScrollView; }
/* harmony export */ });
/* harmony import */ var _tamagui_stacks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43702);
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);
/* harmony import */ var react_native_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6765);



const ScrollView = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(react_native_web__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
  name: "ScrollView",
  scrollEnabled: !0,
  variants: {
    fullscreen: {
      true: _tamagui_stacks__WEBPACK_IMPORTED_MODULE_2__/* .fullscreenStyle */ .Xu
    }
  }
}, {
  accept: {
    contentContainerStyle: "style"
  }
});

//# sourceMappingURL=ScrollView.mjs.map


/***/ }),

/***/ 92976:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; }
/* harmony export */ });
/* unused harmony exports H3, H4, H5, H6, Heading */
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);
/* harmony import */ var _Paragraph_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86706);


const Heading = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(_Paragraph_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .n, {
    tag: "span",
    name: "Heading",
    accessibilityRole: "header",
    fontFamily: "$heading",
    size: "$8",
    margin: 0
  }),
  H1 = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(Heading, {
    name: "H1",
    tag: "h1",
    size: "$10"
  }),
  H2 = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(Heading, {
    name: "H2",
    tag: "h2",
    size: "$9"
  }),
  H3 = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(Heading, {
    name: "H3",
    tag: "h3",
    size: "$8"
  }),
  H4 = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(Heading, {
    name: "H4",
    tag: "h4",
    size: "$7"
  }),
  H5 = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(Heading, {
    name: "H5",
    tag: "h5",
    size: "$6"
  }),
  H6 = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(Heading, {
    name: "H6",
    tag: "h6",
    size: "$5"
  });

//# sourceMappingURL=Headings.mjs.map


/***/ }),

/***/ 86706:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17187);
/* harmony import */ var _SizableText_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18796);


const Paragraph = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(_SizableText_mjs__WEBPACK_IMPORTED_MODULE_1__/* .SizableText */ .J, {
  name: "Paragraph",
  tag: "p",
  userSelect: "auto",
  color: "$color",
  size: "$true",
  whiteSpace: "normal"
});

//# sourceMappingURL=Paragraph.mjs.map


/***/ })

}]);